import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=29220e80&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"
import style0 from "./CGU.vue?vue&type=style&index=0&id=29220e80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29220e80",
  null
  
)

export default component.exports